import { Fetcher } from '@this/src/util';

export type PriceResultResponseArgs = {
  flight_number: string;
  changeable: boolean;
  seat_type: string;
  price: number;
  ticket_type: string;
  source: string;
  expire_at: string;
  seat_count: string | null;
};

export type FetchPricesResponseArgs = {
  success: boolean;
  prices: PriceResultResponseArgs[];
  errors?: string[];
  action_ids?: number[];
};

// ステータス確認用レスポンス型
export type ActionStatusResponseArgs = {
  id: number;
  status: string;
};

export type FetchActionStatusResponseArgs = {
  statuses: ActionStatusResponseArgs[];
  all_completed: boolean;
};

export type PriceResultArgs = {
  flightNumber: string;
  changeable: boolean;
  seatType: string;
  price: number;
  ticketType: string;
  source: string;
  expireAt: string;
  seatCount: string | null;
};

export type FetchPricesArgs = {
  success: boolean;
  prices: PriceResultArgs[];
  errors?: string[];
  actionIds?: number[];
};

export type ActionStatusArgs = {
  id: number;
  status: string;
};

export type FetchActionStatusArgs = {
  statuses: ActionStatusArgs[];
  allCompleted: boolean;
};

export type FetchPricesSubmitArgs = {
  from_airport: string;
  to_airport: string;
  target_date: string;
  sources: string[];
  prices_only?: boolean;
};

export const convertPriceResultResponseToArgs = (response: PriceResultResponseArgs): PriceResultArgs => ({
  flightNumber: response.flight_number,
  changeable: response.changeable,
  seatType: response.seat_type,
  price: response.price,
  ticketType: response.ticket_type,
  source: response.source,
  expireAt: response.expire_at,
  seatCount: response.seat_count
});

export const convertFetchPricesResponseToArgs = (response: FetchPricesResponseArgs): FetchPricesArgs => ({
  success: response.success,
  prices: response.prices.map(convertPriceResultResponseToArgs),
  errors: response.errors,
  actionIds: response.action_ids
});

export const convertFetchActionStatusResponseToArgs = (
  response: FetchActionStatusResponseArgs
): FetchActionStatusArgs => ({
  statuses: response.statuses,
  allCompleted: response.all_completed
});

export const fetchDomesticAirPrices = async (params: FetchPricesSubmitArgs): Promise<FetchPricesArgs> => {
  const response = await Fetcher.post<FetchPricesResponseArgs>('/domestic_air_prices', params);
  return convertFetchPricesResponseToArgs(response);
};

export const fetchActionStatus = async (actionIds: number[]): Promise<FetchActionStatusArgs> => {
  const response = await Fetcher.get<FetchActionStatusResponseArgs>(
    `/domestic_air_fetch_actions/status?action_ids=${actionIds.join(',')}`
  );
  return convertFetchActionStatusResponseToArgs(response);
};
